import {useDisclosure} from '@mantine/hooks';
import {MdPeopleAlt} from 'react-icons/md';
import {
  COLOR_BLACK_2,
  COLOR_WHITE,
} from '../../../../config/constants/colorCodes';
import {useHandleFollowingCommunityTopic} from '../../../../core/usecases/useHandleLikeCommunityTopic';
import {NoLoginAlertModal} from '../../../../shared/components/NoLoginAlertModal';

type Props = {
  topicId: number;
  isFollowedInitial: boolean;
  followCountInitial: number;
  isSignedIn: boolean;
};

export const TopicFollowButton: React.FC<Props> = ({
  topicId,
  isFollowedInitial,
  followCountInitial,
  isSignedIn,
}) => {
  const {handleFollowingCommunityTopic, followCount, isFollowed} =
    useHandleFollowingCommunityTopic({
      topicId,
      followCountInitial,
      isFollowedInitial,
    });

  const [
    isNoLoginModalOpened,
    {open: openNoLoginModal, close: closeNoLoginModal},
  ] = useDisclosure(false);

  return (
    <>
      <button
        type="button"
        className={`border-[2px] ${isFollowed ? 'border-primary-1 bg-primary-1' : 'border-black-2'} border-collapse rounded-full hover:opacity-80 flex items-center py-4 px-12 w-[80px]`}
        onClick={() => {
          if (!isSignedIn) {
            openNoLoginModal();
            return;
          }
          handleFollowingCommunityTopic();
        }}
      >
        <div className="mr-4">
          <MdPeopleAlt
            size={18}
            color={isFollowed ? COLOR_WHITE : COLOR_BLACK_2}
          />
        </div>
        <p
          className={`text-sm ${isFollowed ? 'text-white' : 'text-black-2'} font-bold leading w-[calc(100%-22px)] text-center`}
        >
          {followCount}
        </p>
      </button>
      <NoLoginAlertModal
        opened={isNoLoginModalOpened}
        onClose={closeNoLoginModal}
      />
    </>
  );
};
